<div [className]="!((uiPathList$ | async) && (uiPathList$ | async).length) ? 'bmc-uipath__hidden' : 'bmc-uipath'">
  <bots-list class="bmc-uipath__left-side-component" [botsList]="(uiPathList$ | async)"
    [isLoading]="(isLoading$ | async)" (selectedBotChanged)="onSelectedBotChanged($event)" #botsList></bots-list>
  <uipath-detail-wrapper [ngClass]="{'bmc-uipath__hidden': !((uiPathList$ | async) && (uiPathList$ | async).length) }"
    #uiPathDetailWrapper>
  </uipath-detail-wrapper>
</div>
<bots-empty *ngIf="(!(uiPathList$ | async) || !(uiPathList$  | async).length) && !(isLoading$ | async)">
  {{'RPA_BOTS.EMPTY' | translate}}
</bots-empty>
